module.exports = __webpack_public_path__ + "assets/images/cosmote_9.3ddf6c3b14fb330355fc6d3e24439e71.png";